// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { UpdateReadSupport } from '../../../apis/base';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
const { updateReadSupportActions } = actionCreatorsList;

const outputActions = {
  success: updateReadSupportActions.success,
  failure: updateReadSupportActions.failure
};

type RequestActionTypes = ActionType<typeof updateReadSupportActions.request>;
type OutputActionTypes = ActionType<typeof outputActions>;

const updateReadSupportEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      getType(updateReadSupportActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      const { id }= action.payload
      return UpdateReadSupport(id)
        .then(response => {
          return outputActions.success({ ...response.data })
        })
        .catch((error: AxiosError) => {
          console.log(error)
          return outputActions.failure({ error });
        });
    })
  );
};

export { updateReadSupportEpic as default };

